import { useShallow } from "zustand/react/shallow";

import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import { selectColumnsConfig } from "ds/components/Table/Settings/utils";
import TableSettingsDrawerContent from "ds/components/Table/Settings/DrawerContent";

import useIacManagementAnalytics from "../../useIacManagementAnalytics";
import useIacTableStore from "../../components/Table/useIacTableStore";

const TableSettingsDrawer = createDrawer(() => {
  const { trackAnalytics } = useIacManagementAnalytics();

  const { columnsConfig, columnsState, updateColumnsConfig, resetColumnsConfig } = useIacTableStore(
    useShallow((state) => ({
      columnsConfig: selectColumnsConfig(state),
      columnsState: state.columnsState,
      updateColumnsConfig: state.updateColumnsConfig,
      resetColumnsConfig: state.resetColumnsConfig,
    }))
  );

  return (
    <TableSettingsDrawerContent
      trackAnalytics={trackAnalytics}
      columnsConfig={columnsConfig}
      columnsState={columnsState}
      resetColumnsConfig={resetColumnsConfig}
      updateColumnsConfig={updateColumnsConfig}
    />
  );
});

export const showTableSettingsDrawer = createDrawerTrigger(TableSettingsDrawer);
